module.exports = __webpack_public_path__ + "img/asian-beef-noodles-1.c174401a.jpg";